function getFormErrorObjectForPath(stateErrors: any, fieldPath: string): { type: string; message: string; ref: any } {
    const normalizedPath = fieldPath.replace(/\[(\d+)\]/g, ".$1")
    return normalizedPath.split(".").reduce((obj, key) => obj?.[key], stateErrors)
}

export function hasAnyErrorsForFieldPathsAndTexts(stateErrors: any, fieldPaths: string[], texts: string[]) {
    return (
        fieldPaths.map((fp) => getFormErrorObjectForPath(stateErrors, fp)).filter((o) => !!o && texts.includes(o.message))
            .length > 0
    )
}
